/* eslint-disable no-unused-vars */
import { useState } from "react";
import { parseDV01Input } from "@/lib/businessRules/dv01Rule";
import { returnDV0_Formatted } from "@/lib/globalFormatterHelper";

// LQC-2941 (spec F3) - the Risk (DV01) entry. At rest it reads like the grid's Risk column
// ("2 k", whole numbers, no sign); while typing it is a plain number, "5k" allowed.

interface IDV01Input {
  value: number | null;
  onCommit: (dv01: number | null) => void;
  testId: string;
  // Set when there is no risk to work from; the input is disabled and says why.
  disabledReason?: string;
}

export function returnDV01Display(value: number | null): string {
  return value === null ? "" : returnDV0_Formatted(value);
}

const DV01Input = ({ value, onCommit, testId, disabledReason }: IDV01Input) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState("");
  const isDisabled = !!disabledReason;

  return (
    <div className="flex h-[28px] w-full items-center rounded-md border border-gray-300 dark:border-gray-600 dark:bg-gray-800">
      <input
        data-testid={testId}
        id={testId}
        type="text"
        inputMode="decimal"
        disabled={isDisabled}
        title={disabledReason}
        placeholder={isDisabled ? "-" : "e.g. 5k"}
        className="h-full w-full bg-transparent px-2 text-xs outline-none disabled:cursor-not-allowed disabled:opacity-60 dark:text-gray-200"
        value={isEditing ? localValue : returnDV01Display(value)}
        onFocus={(e) => {
          setLocalValue(value === null ? "" : String(Math.round(Math.abs(value))));
          setIsEditing(true);
          // Select after the "2 k" to "2090" swap renders, so typing replaces, not appends.
          const input = e.currentTarget;
          requestAnimationFrame(() => input.select());
        }}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={() => {
          setIsEditing(false);
          // Unchanged: leave the size alone rather than re-round it from a rounded DV01.
          if (value !== null && localValue === String(Math.round(Math.abs(value)))) return;
          onCommit(parseDV01Input(localValue));
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.currentTarget.blur();
        }}
      />
    </div>
  );
};

export default DV01Input;
